import { useState } from 'react';
import { initSortConfig } from '../../../utils';

const State = () => {
  const [interactions, setInteractions] = useState([]);
  const [query, setQuery] = useState('');
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingUpdate, setLoadingUpdate] = useState(false);
  const [editedScores, setEditedScores] = useState({});
  const [sortConfig, setSortConfig] = useState(initSortConfig);

  return {
    interactions,
    setInteractions,
    query,
    setQuery,
    open,
    setOpen,
    loading,
    setLoading,
    loadingUpdate,
    setLoadingUpdate,
    editedScores,
    setEditedScores,
    sortConfig,
    setSortConfig,
  };
};

export default State;
